export const transientStatusToastContainerId = 'connection-status-toast-container';
